import { render, staticRenderFns } from "./SuiteEditor.vue?vue&type=template&id=0f36a4bc&"
import script from "./SuiteEditor.vue?vue&type=script&lang=ts&"
export * from "./SuiteEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports